import { useContext } from 'react';
import { ServiceWorkerContext } from '../context/service-worker-context';

export const useServiceWorker = () => {
  return useContext(ServiceWorkerContext);
};
